import { memo, useCallback } from 'react'
import { useSelector } from 'react-redux'
import { useTimelineContext } from 'context/TimelineContext'

import { PlayPauseButton as ReusablePlayPauseButton } from 'components/PlayPauseButton'
import { projectDataSelectors } from 'store/features/projectData/selectors'
import { editorSelectors } from 'store/features/editor/selectors'
import { useGetCurrentPlayheadTime } from 'hooks/timeline'
import { disableScreenWake, enableScreenWake } from 'utils/screen-wake'

const PlayPauseButton = () => {
  const { isPlaying, onPlay, onPause } = useTimelineContext()
  const projectDuration = useSelector(projectDataSelectors.duration)
  const isAnyBuffering = useSelector(editorSelectors.isAnyBuffering)
  const isTimelineEmpty = useSelector(projectDataSelectors.isTimelineEmpty)

  const currentTime = useGetCurrentPlayheadTime()

  const onPlayHandler = useCallback(() => {
    onPlay()
    enableScreenWake()
  }, [onPlay])

  const onPauseHandler = useCallback(() => {
    onPause()
    disableScreenWake()
  }, [onPause])

  return (
    <ReusablePlayPauseButton
      duration={projectDuration}
      initialTime={currentTime}
      isPlaying={isPlaying}
      disabled={isAnyBuffering || isTimelineEmpty}
      onPlay={onPlayHandler}
      onPause={onPauseHandler}
    />
  )
}

export default memo(PlayPauseButton)
